import { graphqlRequest } from "../graphqlClient";
import type {
  ParentCategoryViewConnection,
  ParentChildCategoryViewConnection,
  ParentChildCategoryViewFilterInput,
} from "../models/parentChildCategoryView";

export interface ParentChildCategoryViewSortInput {
  field: string;
  order: "Ascending" | "Descending";
}

interface ParentChildCategoryViewListResponse {
  parentChildCategories: {
    parentChildCategoryViewList: ParentChildCategoryViewConnection;
  };
}

export async function getParentChildCategoriesGraphql(
  filter?: ParentChildCategoryViewFilterInput,
  first?: number,
  after?: string,
  sort?: ParentChildCategoryViewSortInput[],
): Promise<ParentChildCategoryViewConnection> {
  const query = `
    query ParentChildCategoryViewList($filter: ParentChildCategoryViewFilterInput, $first: Int, $after: String, $sort: [ParentChildCategoryViewSortSortByInput!]) {
      parentChildCategories {
        parentChildCategoryViewList(filter: $filter, first: $first, after: $after, sort: $sort) {
          edges {
            cursor
            node {
              id
              parentCategory
              subcategoryName
              description
              isActive
              parentCategoryId
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  `;
  const data = await graphqlRequest<ParentChildCategoryViewListResponse>(
    query,
    {
      filter,
      first,
      after,
      sort,
    },
  );
  return data.parentChildCategories.parentChildCategoryViewList;
}

interface ParentChildCategoryViewCountResponse {
  parentChildCategories: {
    parentChildCategoryViewCount: number;
  };
}

export async function getParentChildCategoriesCount(
  filter?: ParentChildCategoryViewFilterInput,
): Promise<number> {
  const query = `
    query ParentChildCategoryViewCount($filter: ParentChildCategoryViewFilterInput) {
      parentChildCategories {
        parentChildCategoryViewCount(filter: $filter)
      }
    }
  `;
  const data = await graphqlRequest<ParentChildCategoryViewCountResponse>(
    query,
    {
      filter,
    },
  );
  return data.parentChildCategories.parentChildCategoryViewCount;
}

interface ParentChildCategoryViewDistinctValuesResponse {
  parentChildCategories: {
    parentChildCategoryViewDistinctValues: string[];
  };
}

export async function getParentChildCategoryDistinctValues(
  field: string,
): Promise<string[]> {
  const query = `
    query ParentChildCategoryViewDistinctValues($field: String!) {
      parentChildCategories {
        parentChildCategoryViewDistinctValues(field: $field)
      }
    }
  `;
  const data =
    await graphqlRequest<ParentChildCategoryViewDistinctValuesResponse>(query, {
      field,
    });
  return data.parentChildCategories.parentChildCategoryViewDistinctValues;
}

interface ParentCategoryViewListResponse {
  parentChildCategories: {
    parentCategoryViewList: ParentCategoryViewConnection;
  };
}

export async function getParentCategoriesGraphql(
  first?: number,
  after?: string,
): Promise<ParentCategoryViewConnection> {
  const query = `
    query ParentCategoryViewList($first: Int, $after: String) {
      parentChildCategories {
        parentCategoryViewList(first: $first, after: $after) {
          edges {
            cursor
            node {
              id
              name
              isActive
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  `;
  const data = await graphqlRequest<ParentCategoryViewListResponse>(query, {
    first,
    after,
  });
  return data.parentChildCategories.parentCategoryViewList;
}
